<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween handle">
    <h2 class="t-widgetTitle">
      {{ "translate.order.emails.title" | translate }}
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container">
  <div class="l-align-spaceBetween top-row">
    <!--template-->
    <input-wrap
      label="{{ 'translate.general.templateDescr' | translate }}"
      cssClass="l-cell-spread"
      [loading]="templates && templates.loading"
    >
      <p-select
        class="t-input--colored"
        [options]="templates"
        [(ngModel)]="selectedTemplate"
        [placeholder]="'translate.general.choose' | translate"
        optionLabel="label"
        appendTo="body"
        (onChange)="onTemplateSelected()"
        [disabled]="!editable"
      ></p-select>
    </input-wrap>

    <!--recipients-->
    <input-wrap
      label="{{ 'translate.order.emails.recipients' | translate }}"
      cssClass="l-cell-spread"
    >
      <p-autoComplete
        class="t-input--colored"
        [(ngModel)]="email.recipients"
        [disabled]="!editable || !selectedTemplate"
        [multiple]="true"
        [typeahead]="false"
        [placeholder]="'translate.order.emails.recipients' | translate"
      />
    </input-wrap>
  </div>

  <p class="t-panel-cell c-warn" *ngIf="selectedTemplate && editable">
    {{ "translate.order.emails.changeTemplateAlert" | translate }}
  </p>

  <div class="w-full">
    <!--subject-->
    <input-wrap
      label="{{ 'translate.order.emails.subject' | translate }}"
      cssClass="l-cell-spread"
    >
      <input
        type="text"
        [(ngModel)]="email.subject"
        class="t-input t-input--colored"
        [disabled]="!editable || !selectedTemplate"
      />
    </input-wrap>
  </div>

  <div class="w-full">
    <input-wrap cssClass="t-inputWrap-spread-y" class="t-scrollbar">
      <textarea
        dir="auto"
        class="t-input t-input--colored l-cell-spread-y t-scrollbar"
        [(ngModel)]="email.body"
        cssClass="w-full"
        pInputTextarea
        [autoResize]="true"
        [readOnly]="!editable || !selectedTemplate"
      ></textarea>
    </input-wrap>
  </div>

  <div class="bottom-container">
    <!--info-->
    <div class="task-info">
      <p *ngIf="email.updDate">
        {{ "translate.tasks.updatedAt" | translate }}
        <span>{{ email.updDate | date : "dd/MM/yy HH:mm" }}</span>
        {{ "translate.tasks.updatedBy" | translate }}
        <span>{{ email.updUserDescr }}</span>
      </p>

      <p *ngIf="email.sendDate">
        {{ "translate.order.emails.sentAt" | translate }}
        <span>{{ email.sendDate | date : "dd/MM/yy HH:mm" }}</span>
      </p>
    </div>

    <div class="action-container t-buttonSet l-align-end">
      <spinner *ngIf="saving"></spinner>

      <button
        *ngIf="editable && email.id"
        [disabled]="saving"
        (click)="cancelAlert()"
        class="t-button-outline warn"
      >
        {{ "translate.order.emails.cancelAlert" | translate }}
      </button>

      <button
        *ngIf="editable"
        [disabled]="saving || !saveEnabled()"
        (click)="save('NEW')"
        class="t-button-outline"
      >
        {{ "translate.order.emails.save" | translate }}
      </button>

      <button
        *ngIf="editable"
        [disabled]="saving || !sendEnabled()"
        (click)="save('SENT')"
        class="t-button-outline"
      >
        {{ "translate.order.emails.saveAndSend" | translate }}
      </button>
    </div>
  </div>
</div>
